<script>import ButtonSVG from "./ButtonSVG.svelte";
import ButtonBox from "./ButtonBox.svelte";
export let rounded;
export let white;
</script>

{#if rounded}
	<ButtonBox
		data-glide-dir=">"
		props={{
			iconLeft: 'arrow_right',
			roundedFull: true,
			size: 'default',
			iconSize: 'small',
			classNames: `border ${white ? 'border-white text-white' : 'border-text'}`
		}}
	/>
{:else}
	<ButtonSVG data-glide-dir=">" props={{ name: 'arrow_right_alt' }} />
{/if}
